<template>
  <div>
    {{str}}
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      str: '通用顶部栏和底部栏'
    }
  },
  methods:{

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Plan/Plan.vue